"use strict";
// Singleton context for inline modules
Object.defineProperty(exports, "__esModule", { value: true });
exports.inlineModulesContext = exports.collectUriToLayoutMapping = void 0;
var font_utils_1 = require("../fonts/font-utils");
/**
 * runs through ast and finds all occurrences of wixMediaUrl formatter.
 * For every occurrence, an entry with the matching component layout is saved onto uriToLayoutMapping
 * @param meta - stylable meta to scan
 * @param uriToLayoutMapping - mapping object which will be changed by this function
 * @param compLayout - connected component layout
 */
function collectUriToLayoutMapping(meta, uriToLayoutMapping, compLayout) {
    meta.ast.walkDecls(function (decl) {
        var regex = new RegExp(/wixMediaUrl\(\s*(\S*)\s*,\s*(\S*)\s*,\s*(\S*)\s*\)/g); // Retrieve formatter args
        var result;
        do {
            result = regex.exec(decl.value);
            if (result) {
                // formatter found
                var uri = result[1], width = result[2], height = result[3];
                // Add comp layout to map under matching uri:
                uriToLayoutMapping[uri] = uriToLayoutMapping[uri] || [];
                uriToLayoutMapping[uri].push({
                    layout: compLayout,
                    originalWidth: Number.parseInt(width, 10),
                    originalHeight: Number.parseInt(height, 10)
                });
            }
        } while (result);
    });
}
exports.collectUriToLayoutMapping = collectUriToLayoutMapping;
function getMinimumRequiredDimensionsForUri(uriToLayoutMapElement) {
    var maxWidth = 0;
    var maxHeight = 0;
    // Find max width+height
    uriToLayoutMapElement.forEach(function (item) {
        var originalWidth = item.originalWidth, originalHeight = item.originalHeight;
        var componentWidth = item.layout ? item.layout.width : 0;
        var componentHeight = item.layout ? item.layout.height : 0;
        var widthRatio = componentWidth / originalWidth;
        var heightRatio = componentHeight / originalHeight;
        // Find target dimensions while keeping aspect ratio:
        var targetWidth = originalWidth;
        var targetHeight = originalHeight;
        if (widthRatio > heightRatio) {
            targetWidth = componentWidth;
            targetHeight = originalHeight * widthRatio;
        }
        else {
            targetHeight = componentHeight;
            targetWidth = originalWidth * heightRatio;
        }
        // Take greatest dimension pair
        if (targetWidth > maxWidth) {
            maxWidth = targetWidth;
            maxHeight = targetHeight;
        }
    });
    return { maxWidth: maxWidth, maxHeight: maxHeight };
}
var InlineModulesContext = /** @class */ (function () {
    function InlineModulesContext() {
        var _this = this;
        this.staticMediaUrl = '';
        this.uriToLayoutMap = {};
        this.shouldUseWebp = false;
        this.fontThemes = {};
        this.onSetFonts = function () { return; };
        this.setStaticMediaUrl = function (newStaticMediaUrl) { return (_this.staticMediaUrl = newStaticMediaUrl); };
        this.setUseWebp = function (shouldUseWebpIfPossible) { return (_this.shouldUseWebp = shouldUseWebpIfPossible); };
        this.setFontThemes = function (themeData) {
            _this.fontThemes = font_utils_1.getFontThemeClasses(themeData);
            _this.onSetFonts();
        };
    }
    InlineModulesContext.prototype.setUriToLayoutMap = function (uriToLayoutsMap) {
        var _this = this;
        this.uriToLayoutMap = {};
        // Calculate and store minimal need dimensions per found uri (consolidating all URI appearances)
        Object.keys(uriToLayoutsMap).forEach(function (uri) {
            var uriToLayoutMapElement = uriToLayoutsMap[uri];
            var _a = getMinimumRequiredDimensionsForUri(uriToLayoutMapElement), maxWidth = _a.maxWidth, maxHeight = _a.maxHeight;
            if (maxWidth !== 0 && maxHeight !== 0) {
                _this.uriToLayoutMap[uri] = { width: maxWidth, height: maxHeight };
            }
        });
    };
    return InlineModulesContext;
}());
exports.inlineModulesContext = new InlineModulesContext();
//# sourceMappingURL=context.js.map